import React, {useState, useEffect, useContext} from 'react'
import {Link} from 'react-router-dom'
import swal from 'sweetalert'
import {ContextApp} from '../context/ContextApp'

const Successs = () => {
  const contextApp = useContext(ContextApp)
  const {
    user,
    setCategoryShowClose,
    orderCreated,
    cleanCarShoppingAll,
  } = contextApp

  useEffect(() => {
    setCategoryShowClose()
    cleanCarShoppingAll()
  }, [])

  const {client, delivery, source, create_at, items, total, id} = orderCreated
  //const { email, name, phone } = client

  return (
    <div className="success-wrapper-section">
      <h1>Orden creada #{id} con éxito!</h1>
      <p>Gracias por comprar en AeroMall.com, Tu Almacén Virtual</p>
      <div className="grid-order-details">
        <div className="success-details">
          <h5>Información comprador:</h5>
          <ul>
            <li>
              Nombre: <span>{user.user.name}</span>
            </li>
            <li>
              Correo: <span>{user.user.email}</span>
            </li>
            <li>
              Teléfono: <span>{user.user.phone}</span>
            </li>
          </ul>
          {/* <h5>Infrmación de pago</h5>
                    <ul>
                        <li
                            style={{
                                fontSize: '1.1rem',
                                fontWeight: 'bold'
                            }}
                        >Total a pagar: ${total}</li>
                    </ul> */}
        </div>
        <div className="products-order">
          <h4>Información de la orden:</h4>
          <ul>
            <li>
              Método de pago: <span>{source}</span>
            </li>
          </ul>
          {/* <h5>Productos:</h5>
                    <ol className="products-buy">
                        {items.map((item) => (
                            <li>{item.batch.name}</li>
                        ))}
                    </ol> */}
        </div>
      </div>
    </div>
  )
}

export default Successs
